import { combineReducers } from "redux";
import loadingReducer from "./loadingReducer";
import { SET_STATE_UNDIFINED } from "../types";
import phantomReducer from "./phantomReducer";
import creatorsReducer from "./creatorsReducer";
import nftReducer from "./nftReducer";
import authReducer from "./authReducer";
import modalReducer from "./modalReducer";

const appReducer = combineReducers({
    loading: loadingReducer,
    phantom: phantomReducer,
    creators: creatorsReducer,
    nfts: nftReducer,
    auth: authReducer,
    modal: modalReducer,
});

const rootReducer = (state, action) => {
    if (action.type === SET_STATE_UNDIFINED) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
